module.exports = __webpack_public_path__ + "img/12_review.0dbb94fc.png";